<template>
  <el-dialog
    title="请输入支付码"
    width="400px"
    :visible.sync="dialogPayCode.isShow"
    append-to-body
    @opened='Opened'
  >
    <el-form @submit.native.prevent>      
      <el-form-item >
        <el-col :span="18">
          <el-input 
            ref="number"
            placeholder="请输入支付码" 
            @keyup.enter.native="submit"
            prefix-icon="el-icon-menu"
            v-model="number">             
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" v-on:click="submit" >确定</el-button>
        </el-col>
      </el-form-item>
    </el-form>   
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   export default {
    props:{
      dialogPayCode:{}
    },
    data(){
      return {
        number:''
      }
    },
    mounted(){      
    },
    methods:{
      Opened:function(){
        this.number = ''
        this.$refs.number.focus()
      },
      submit:function(){
       this.$emit('UpdatePayCode',this.number)
       this.dialogPayCode.isShow = false
      }
    }
   }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-button--primary
  margin-left 5px
</style>
